import React from 'react';

export default () => (
  <svg width="30" height="30" viewBox="-1 -1 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g stroke="#21304A">
        <rect fill="none" width="30" height="30" rx="5" />
        <g transform="translate(5 5)">
          <rect fill="none" x="8" y="6.2" width="12" height="13" rx="2" />
          <rect fill="none" y=".2" width="12" height="13" rx="2" />
          <path d="M6 6.146l7.5 5" strokeLinecap="round" strokeLinejoin="round" />
          <circle fill="none" cx="4.75" cy="4.896" r="1.75" />
          <circle fill="none" cx="15.25" cy="12.396" r="1.75" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-reference-small.es6.js